module.exports = __webpack_public_path__ + "img/grid-dividers.ab2c32ca.svg";